<template>
	<div class="">
		<div class="footer">
			<div class="content">
				<div class="left">
					<div class="tit">产品服务</div>
					<a @click="toAim('yun')">云平台</a>
					<a @click="toAim('chuan')">可穿戴设备</a>
					<a @click="toAim('vr')">VR系统</a>
				</div>
				<div class="left right">
					<div class="tit">联系我们</div>
					<p href="">电话：+86-13245888380</p>
					<p href="">邮箱：info@braintechnet.com</p>
					<p href="">技术支持：support@braintechnet.com</p>
					<p href="">联系地址：南京市鼓楼区中央北路73号1幢312-183室</p>
				</div>
				<!-- <div class="right">
					<div class="tit">
						APP下载
					</div>
					<div class="box">
						<div class="">
							<img src="@/assets/logo.png" alt="">
							<p>Android</p>
						</div>
						<div class="">
							<img src="@/assets/logo.png" alt="">
							<p>IOS</p>
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="smallfooter">
			<div class="left">
				<div class="tit">联系我们</div>
				<p>
					电话：
					<span>+86-13245888380</span>
				</p>
				<p>
					邮箱：
					<span>info@braintechnet.com</span>
				</p>
				<p>
					技术支持：
					<span>support@braintechnet.com</span>
				</p>
				<p>
					联系地址：
					<span>南京市鼓楼区中央北路73号1幢312-183室</span>
				</p>
			</div>
			<!-- <div class="right">
				<div class="box">
					<div class="">
						<img src="@/assets/logo.png" alt="" />
						<p>Android</p>
					</div>
					<div class="">
						<img src="@/assets/logo.png" alt="" />
						<p>IOS</p>
					</div>
				</div>
			</div> -->
		</div>
		<div class="bottom">
			© 版权所有 2022 脑结构（南京）科技有限公司
			<a href=" http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32010602011194&token=58bbe833-ae1f-4868-9716-3d5a23478f89" target="_blank">
				<img src="../assets/beian.png" alt="" />
				苏公网安备 32010602011194号
			</a>
			<a href=" https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
				<span>备案号：</span>
				苏ICP备20009768号-2
			</a>
		</div>
	</div>
</template>

<script>
import { GlobalMixin } from '@/util/globalMixin';
export default {
	name: 'Footer',
	mixins: [GlobalMixin],
	methods: {
		toAim(id) {
			if (this.$route.path == '/ProductCenter') {
				this.$router.go(0);
				// document.getElementById(id).scrollIntoView(true)
				return;
			}
			localStorage.setItem('name', id);
			this.$router.push({
				path: '/ProductCenter' //跳转页面的name,如果目标位置内容是组件则name是父组件的name
			});
		}
	}
};
</script>

<style lang="less">
.footer {
	width: 100%;
	background: linear-gradient(to right, #002541 35%, #001d32 0);
	padding-bottom: 50px;

	.content {
		overflow: hidden;
	}

	.tit {
		font-size: 16px;
		font-weight: 400;
		color: #fefefe;
		margin-top: 63px;
		margin-bottom: 35px;
	}

	.tit::after {
		content: '';
		display: block;
		width: 24px;
		height: 2px;
		background: #ffffff;
		border-radius: 1px;
		margin-top: 15px;
	}

	.left {
		overflow: hidden;
		float: left;
		width: 35%;

		p,
		a {
			display: block;
			font-size: 15px;
			color: #9b9fb4;
			margin-bottom: 25px;
			text-decoration: auto;
			cursor: pointer;
		}
	}

	.right {
		width: 65%;
		overflow: hidden;

		.box {
			display: flex;
			text-align: center;

			div {
				margin-right: 30px;
			}

			img {
				width: 110px;
				height: 110px;
				margin-bottom: 13px;
			}

			p {
				font-size: 14px;
				font-weight: 400;
				color: #9b9fb4;
				line-height: 36px;
			}
		}
	}
}

.bottom {
	width: 100%;
	min-height: 88px;
	background: #010a10;
	text-align: center;
	font-size: 15px;
	color: #ffffff;
	padding: 20px 0;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	a {
		text-decoration: none;
		color: #fff;
		display: flex;
		align-items: center;
	}
	img {
		margin-left: 30px;
		margin-right: 8px;
	}
	span {
		margin-left: 30px;
	}
}

.smallfooter {
	width: 100%;
	height: 490px;
	background: #001d32;
	padding: 0 30px;
	box-sizing: border-box;
	overflow: hidden;
	display: flex;
	align-items: center;
	margin-top: -2px;
	justify-content: space-around;
	display: none;
	.left {
		width: 100%;
	}
	.tit {
		font-size: 30px;
		font-weight: 400;
		color: #fefefe;
		margin-bottom: 66px;
	}

	.tit::after {
		content: '';
		display: block;
		width: 24px;
		height: 2px;
		background: #ffffff;
		border-radius: 1px;
		margin-top: 13px;
	}

	.left {
		p {
			font-size: 26px;
			color: #9b9fb4;
			margin-bottom: 25px;

			// span {
			// 	display: block;
			// }
		}
	}

	.right {
		img {
			width: 168px;
			height: 168px;
		}

		p {
			text-align: center;
			font-size: 24px;
			color: #9b9fb4;
			margin: 10px 0 35px;
		}
	}
}

@media (max-width: 768px) {
	.footer {
		display: none;
	}

	.smallfooter {
		display: flex;
	}
}
</style>
